import { FetcherAmplify } from 'src/business/Libraries/Fetcher/FetcherAmplify';
import { AccountProofI, UploadAccountProofParams } from '../domain';
import AccountRepositoryI from './AccountRepositoryI';

export default class AccountRepository implements AccountRepositoryI {
  constructor(private fetcher: FetcherAmplify) {}

  public async uploadProof({
    customerId,
    accountId,
    file,
  }: UploadAccountProofParams): Promise<AccountProofI> {
    const formData = new FormData();
    formData.append('file', file);
    return this.fetcher.post(
      `/v1/customers/${customerId}/accounts/${accountId}/proof`,
      { body: formData },
    );
  }
}
